import { AsYouType, type CountryCode } from "libphonenumber-js";

/**
 * Drops the national trunk prefix people type out of habit (the "0" in a UK
 * "07911 123456" or an Irish "087 123 4567") so only the number that follows
 * the dial code is left. Countries where the leading 0 is part of the number,
 * like Italy's "06 1234 5678", are left untouched.
 *
 * Without this the phone input's fixed-length mask cuts the last digit off.
 */
export const stripNationalPrefix = (
  nationalInput: string,
  countryIso2: string
): string => {
  const digits = nationalInput.replace(/\D/g, "");
  if (!digits.startsWith("0")) {
    return nationalInput;
  }

  const asYouType = new AsYouType(countryIso2.toUpperCase() as CountryCode);
  asYouType.input(digits);
  const nationalNumber = asYouType.getNationalNumber();

  return nationalNumber === digits ? nationalInput : nationalNumber;
};
